<template>
  <v-menu
    v-model="menu"
    :open-on-hover="false"
    :bottom="true"
    :left="true"
    max-width="300"
    offset-y
    content-class="hidden-sm-and-down"
  >
    <div class="arrow-up"></div>
    <template v-slot:activator="{ on }">
      <v-avatar class="avatar-btn cursor" width="24" height="24" v-on="on">
        <img :src="require('@/assets/images/home/user.svg')" alt="" />
      </v-avatar>
    </template>

    <v-card>
      <v-list>
        <v-list-item class="list-item-border-bottom">
          <div class="user-info">
            <div class="img-wrap">
              <img :src="require('@/assets/images/nav/my-profile-blue.svg')" alt="" width="25" height="22" />
            </div>
            <div>
              <div class="username" @click="$router.push({ path: '/usercenter/account-management' })">
                <span>{{ $t('labels.acc.side.userCenter') }}</span>
              </div>
              <div class="u-id" @click="$router.push({ path: '/usercenter/account-management' })">
                UID: GRX{{ Getter_User_Info.id }}
              </div>
              <div class="user-tags">
                <!--<span>
                  <b class="green">L{{ vipLevel }}</b>
                  {{ $t('header.user.drop.vip.level') }}
                </span>-->
              </div>
            </div>
          </div>
        </v-list-item>

        <v-list-item-group color="primary" class="fun-btn">
          <v-list-item v-for="(btn, index) in btnList" :key="index" @click="btn.handelClick">
            <i class="img-wrap">
              <img :src="btn.icon" alt />
            </i>
            <v-list-item-content>{{ btn.name }}</v-list-item-content>
            <span class="btn-tag" v-for="(tag, index) in btn.tags" :key="index">{{ tag }}</span>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
  </v-menu>
</template>
<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import { actionTypes } from '@/store/action-types';
import { mutationTypes } from '@/store/mutation-types';
import { getterTypes } from '../../store/getter-types';
import { simpleCookie } from '@/common/js/simpleCookie';

export default {
  name: 'UserInfoDrop',
  components: {},
  mounted() {
    this.GET_USER_VIP_ACTION().then(res => {
      // this.vipLevel = this.Getter_User_Vip.vipId;
      this.vipLevel = this.Getter_User_Vip.vipName.substring(3); // remove 'VIP'
    });
  },
  beforeDestroy() {},
  computed: {
    ...mapGetters({ Getter_User_Info: getterTypes.Getter_User_Info, Getter_User_Vip: getterTypes.Getter_User_Vip })
  },
  methods: {
    ...mapActions([actionTypes.GET_USER_VIP_ACTION]),
    ...mapMutations([
      mutationTypes.SET_USERNAME,
      mutationTypes.SET_TOKEN,
      mutationTypes.SET_EXPIRETIME,
      mutationTypes.SET_LASTUPDATETIME
    ]),
    handelNavClick(nav) {
      if (nav.dropdownType) {
        this.handDropDownClick(nav);
      } else if (nav.handelClick) {
        nav.handelClick(nav);
      } else {
        this.$router.push({ name: nav.path });
      }
    },
    handDropDownClick(nav) {
      const nextState = !nav.active;
      this.closeDropdown();
      nav.active = nextState;
    },
    closeDropdown() {
      this.navList.forEach(item => {
        item.active !== undefined && (item.active = false);
      });
    },
    logout() {
      //this.$q.cookies.set('isLogin', false);
      simpleCookie.setItem('isLogin', false);
      this.SET_LASTUPDATETIME('');
      this.SET_EXPIRETIME('');
      this.SET_TOKEN('');
      this.SET_USERNAME('');
      if (this.$route.name === 'home') {
        window.location.reload(true);
      } else {
        this.$router.replace({ name: 'home' });
      }
    }
  },
  data() {
    return {
      menu: false,
      vipLevel: '',
      btnList: [
        {
          name: this.$t('header.user.drop.verification'),
          icon: require('@/assets/images/nav/user_identity.png'),
          handelClick: () => {
            this.$router.push('/usercenter/authentication');
          },
          tags: []
        },
        // {
        //   name: this.$t('header.user.drop.fee.setting'),
        //   icon: require('@/assets/images/nav/user_fee_setting.png'),
        //   handelClick: () => {
        //     this.$router.push('/usercenter/fee-rate');
        //   },
        //   tags: [this.$store.state.userInfo.deductionText],
        // },
        {
          name: this.$t('header.user.drop.invite'),
          icon: require('@/assets/images/nav/user_invite_firends.png'),
          handelClick: () => {
            this.$router.push({ name: 'invite' });
          },
          tags: []
        },
        // {
        //   name: this.$t('header.user.drop.member.level'),
        //   icon: require('@/assets/images/nav/user_menber.png'),
        //   handelClick: () => {
        //     this.$router.push('/usercenter/member-discount');
        //   },
        //   tags: [this.$store.state.userInfo.memberText],
        // },
        {
          name: this.$t('header.user.drop.logout'),
          icon: require('@/assets/images/nav/user_log_out.png'),
          handelClick: () => {
            this.logout();
          },
          tags: []
        }
      ]
    };
  }
};
</script>
<style scoped>
.user-info {
  display: flex;
  padding: 10px 0px;
}
.user-info > div:last-child {
  flex: 1 1 0px;
}
.img-wrap {
  display: inline-block;
  height: 100%;
  padding-right: 12px;
  width: 34px;
}
.fun-btn li i {
  display: flex;
  align-items: center;
  width: 30px;
  margin-right: 10px;
}
.fun-btn li {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  font-size: 14px;
  line-height: 40px;
  height: 40px;
  color: #666666;
  padding: 10px 20px;
}
.fun-btn {
  font-size: 14px;
  color: #333;
  /* padding: 10px 20px; */
}
.u-id {
  font-size: 12px;
  line-height: 20px;
  color: rgba(138, 144, 154, 1);
}
.user-tags {
  display: flex;
  padding: 6px 6px 0 6px;
  white-space: nowrap;
}
.user-tags span {
  position: relative;
  display: inline-block;
  /* flex: 1 1 0px; */
  line-height: 20px;
  padding-right: 6px;
  padding-left: 20px;
  margin-right: 20px;
  font-size: 12px;
  color: rgba(138, 144, 154, 1);
  border-radius: 0px 8px 8px 0px;
  background: rgba(230, 234, 240, 1);
  opacity: 1;
}

.user-tags span b {
  left: -10px;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  display: flex;
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  background-color: #ffb207;
  align-items: center;
  justify-content: center;
  padding: 4px;
  color: #fff;
}

.user-tags span b.green {
  background-color: #20ce8b;
}

.username {
  white-space: nowrap;
  color: #4d67b2;
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
  position: relative;
  padding-right: 20px;
  cursor: pointer;
}
.username i {
  font-style: normal;
  background: rgba(255, 178, 7, 1);
  opacity: 1;
  border-radius: 2px;
  padding: 0 6px;
  margin: 0 8px;
  height: 16px;
  font-size: 11px;
  font-weight: bold;
  line-height: 16px;
  color: rgba(255, 255, 255, 1);
}
.username::after {
  position: absolute;
  display: block;
  content: '';
  width: 14px;
  height: 14px;
  border-top: 3px solid #ccc;
  border-right: 3px solid #ccc;
  right: 0;
  top: 50%;
  transform: translateY(-50%) rotate(45deg) scale(0.5, 0.5);
}
.btn-tag {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: rgba(255, 255, 255, 1);
  background: rgba(255, 178, 7, 1);
  border-radius: 0px 4px 0px 4px;
  padding: 0 6px;
  margin-left: 6px;
}
.arrow-up {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid white;
  margin-left: 82%;
  margin-top: 2%;
}
.list-item-border-bottom {
  border-bottom: 1px solid rgba(230, 234, 240, 1);
}
</style>
